module.exports = __webpack_public_path__ + "fonts/Muli-Regular.047c2441.woff";